import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

export const useAuthToken = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();
  const [token, setToken] = useState<string>("");

  useEffect(() => {
    let cancelled = false;
    if (isAuthenticated) {
      (async () => {
        try {
          const accessToken = await getAccessTokenSilently();
          if (!cancelled) {
            setToken(accessToken);
          }
        } catch (error) {
          console.error("Failed to acquire access token:", error);
        }
      })();
    }
    return () => {
      cancelled = true;
    };
  }, [getAccessTokenSilently, isAuthenticated]);

  return token ?? "";
};
